<template>
	<div class="content">

		<div class="md-layout">
			<div class="md-layout-item md-medium-size-100 md-size-100">
				<md-card>
					<div class="md-layout">
						<div class="md-layout-item md-small-size-100 md-size-25 text-center">
							<router-link to="/dashboard">
								<img src="@/assets/img/logo-login.png" style="margin: 13px  0px">
							</router-link>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-75" style="display: flex;align-items: center;">
							<md-field>
								<label>បញ្ចូលឈ្មោះ ឬ​ ទូរស័ព្ទ ​ឬ អត្តសញ្ញាណប័ណ្ណ ឬ លេខការិយាល័យបោះឆ្នោត</label>
								<md-input v-model="search.text" type="text" required @keyup.enter="searchHandler()"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-20">
							<md-field>
								<md-select placeholder="​សាខាគណបក្សសង្កាត់ (ទាំងអស់)" v-model="search.party_commune"
									@md-selected="switchPartyCommune()">
									<md-option value="">ទាំងអស់</md-option>
									<md-option v-for="commune in partyCommuneList" :value="commune.commune_id">
										{{commune.commune_name}}</md-option>
								</md-select>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-20">
							<md-field>
								<md-select placeholder="សាខាគណបក្សភូមិ (ទាំងអស់)" v-model="search.party_village"
									@md-selected="">
									<md-option value="">ទាំងអស់</md-option>
									<md-option v-for="village in partyVillageList" :value="village.village_id">
										{{village.village_name}}
									</md-option>
								</md-select>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-20">
							<md-field>
								<md-select placeholder="ក្រុមបក្ស (ទាំងអស់)" v-model="search.party_village_group"
									@md-selected="">
									<md-option value="">ទាំងអស់</md-option>
									<md-option v-for="i in 50" :value="i+1">ក្រុមលេខ {{i+1}}
									</md-option>
								</md-select>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-20">
							<md-field>
								<md-select placeholder="តួនាទីក្នុងបក្ស (ទាំងអស់)" v-model="search.party_position"
									@md-selected="">
									<md-option value="">ទាំងអស់</md-option>
									<md-option v-for="position in partyPositionList" :value="position.party_position_id">
										{{position.party_position_name}}
									</md-option>
								</md-select>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-20">
							<md-field>
								<md-select placeholder="កម្រិតវប្បធម៌ (ទាំងអស់)" v-model="search.education" @md-selected="">
									<md-option value="">ទាំងអស់</md-option>
									<md-option v-for="education in educationList" :value="education.education_id">
										{{education.education_name}}
									</md-option>
								</md-select>
							</md-field>
						</div>

						<div class="md-layout-item md-small-size-100 md-size-100 text-right">
							<md-button class="md-raised md-primary" @click="searchHandler()">ស្វែងរក
							</md-button>
						</div>
					</div>
				</md-card>

			</div>
		</div>
		<div class="md-layout">
			<div class="md-layout-item md-small-size-100 md-size-100 text-right" style="margin-bottom: 5px">
				({{memberList.length}} លទ្ធផល)</div>
			<div class="md-layout-item md-small-size-100 md-size-33" v-for="member in memberList">
				<md-card>
					<md-card-header style="background-color: #3c79b7;">
						<div class="md-layout-item md-small-size-100 md-size-100"
							style="color: white; display:flex;flex-direction: row;align-items: center;">
							<md-card-media class="profile-container">
								<img :src="config.getProfileUrl(member.picture_url)" :alt="member.name"
									style="border:1px solid white; border-radius: 50%">
							</md-card-media>
							<div class="md-layout-item md-small-size-100 md-size-100">
								<div class="md-title">{{member.name}} ({{getGender(member.gender)}})</div>
								<div class="md-subhead">{{member.party_position_name}} - ក្រុម {{member.party_village_group}}</div>
							</div>
						</div>
					</md-card-header>
					<div class="md-layout-item md-small-size-100 md-size-100" style="color: white;">
						<md-table>
							<md-table-row>
								<md-table-cell>ថ្ងៃខែឆ្នាំកំណើត</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>{{member.birth_date}}</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>អត្តសញ្ញាណប័ណ្ណ</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>{{member.id_number}}</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>លេខទូរស័ព្ទ</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>{{member.phone}}</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>សាសនា</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>{{member.religion_name}}</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>កម្រិតវប្បធម៌</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>{{member.education_name}}</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>តួនាទីរដ្ឋ/មុខរបរ</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>{{member.occupation}}</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>លេខការិយាល័យបោះឆ្នោត</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>{{member.election_office}}</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>សាខាគណបក្សសង្កាត់ ភូមិ</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>{{member.commune_name}} {{member.village_name}}</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>ថ្ងៃខែឆ្នាំចូលបក្ស</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>{{member.party_join_date}}</md-table-cell>
							</md-table-row>
						</md-table>
					</div>




					<md-card-actions>
						<a target="_blank"
							:href="`https://www.google.com/maps/search/?api=1&query=${member.lat},${member.lng}`">
							<md-button class="md-primary">បង្ហាញទីតាំង</md-button>
						</a>

					</md-card-actions>
				</md-card>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {
		},
		created() {
			this.getSettings();
			this.searchHandler();
		},
		data() {
			return {
				search: {
					text: "",
					party_commune: "",
					party_village: "",
					party_village_group: "",
					party_position: "",
					education: "",
				},
				loadMoreCompanyButton: false,
				memberList: [],
				provinceList: [],
				districtList: [],
				communeList: [],
				villageList: [],
				partyCommuneList: [],
				partyVillageList: [],
				partyPositionList: [],
				partyVillageGroupList: [],

				educationList: []
			}
		},
		methods: {
			getSettings() {
				this.$http.get(this.config.api + "/admin/setting/location/get_all").then(data => {
					this.partyCommuneList = data.body.data.commune
					this.districtList = data.body.data.district
					this.communeList = data.body.data.commune
					this.villageList = data.body.data.village
					this.$http.get(this.config.api + "/admin/setting/data/get_all").then(data => {
						this.educationList = data.body.data.education
						this.partyPositionList = data.body.data.party_position
						this.religionList = data.body.data.religion
						this.nationalityList = data.body.data.nationality
						this.loaded = true
					});
				});
			},
			searchHandler() {
				this.$http.post(this.config.api + "/admin/member/search", {
					text: this.search.text,
					party_commune: this.search.party_commune,
					party_village: this.search.party_village,
					party_village_group: this.search.party_village_group,
					party_position: this.search.party_position,
					education: this.search.education,
				}).then(data => {
					this.search.text = "";
					// this.loadMoreCompanyButton = true
					this.memberList = data.body.data;
				})
			},
			switchPartyCommune() {
				this.search.party_village = "", this.partyVillageList = [];
				for (let i = 0; i < this.villageList.length; i++) {
					if (this.villageList[i].commune_id == this.search.party_commune) this.partyVillageList.push(this.villageList[i]);
				}
				// this.checkValidation();
			},
			getGender(type) {
				switch (type) {
					case 'm':
						return "ប្រុស"
					case 'f':
						return "ស្រី"
					default:
						return "ផ្សេងទៀត"
				}
			}
		}
	}
</script>

<style scoped>
	.md-table-cell {
		padding: 5px 8px;
		height: auto;
	}

	.center-item {
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.white {
		color: #FFF !important;
	}

	.profile-container {
		width: 60px !important;
		height: 60px !important;
		margin-left: 0px;
		flex: 0 0 60px !important;
	}
	.md-card .md-title {
		font-size: 20px !important;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Search.vue